import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Quote from 'components/Loans/Quote';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';

const styles = {
  appBar: {
    position: 'relative',
    marginBottom: '20px'
  },
  flex: {
    flex: 1,
  },
}

class QuoteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  transition = (props) => {
    return <Slide direction="up" {...props} />;
  }

  render = () => {
    const { open } = this.state;
    const { classes, buttonLabel, buttonStyles, quote } = this.props;

    return (
      <div>
        <Button
          className={buttonStyles}
          color='primary'
          onClick={() => this.setState({ open: true })}
        >
          {buttonLabel}
        </Button>
        <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={this.transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="default" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className={classes.flex}>
                Quote
              </Typography>
              <Button onClick={this.handleClose} type='submit' color='default'>
                Close
              </Button>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Quote quote={quote}/>
          </DialogContent>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {};
};
const connected = connect(mapStateToProps)(QuoteDialog);
export default withStyles(styles)(connected);




// WEBPACK FOOTER //
// ./src/components/Loans/QuoteDialog.js